import React from "react";
const Error = () => {
  return (
    <div className="section section-center text-center">
      <h2>виникла помилка...</h2>
    </div>
  );
};

export default Error;
